import React from 'react';
import {
  Video,
  Upload,
  MapPin,
  CheckCircle2,
} from 'lucide-react';
import './css/AuditionTypes.css';

const auditionTypes = [
  {
    title: 'Online Virtual',
    icon: <Video size={28} strokeWidth={2.2} />,
    description:
      'Live auditions via Google Meet with automated scheduling and reminders.',
    features: [
      'Google Meet auto-link',
      'Calendar sync',
      'Real-time feedback',
    ],
  },
  {
    title: 'Online Self-Tape',
    icon: <Upload size={28} strokeWidth={2.2} />,
    description:
      'Upload your recorded performance and get instant AI-powered scoring.',
    features: [
      'AI emotion scoring',
      'Voice clarity analysis',
      'Confidence metrics',
    ],
  },
  {
    title: 'Offline Face-to-Face',
    icon: <MapPin size={28} strokeWidth={2.2} />,
    description:
      'Physical auditions with venue details, map links, and check-in tracking.',
    features: [
      'Venue map links',
      'Contact person details',
      'Check-in tracking',
    ],
  },
];

const AuditionTypesSection = () => {
  return (
    <section className="audition-types-section">
      <div className="audition-types-container">
        <div className="audition-types-header">
          <h2>
            Audition <span>Types</span>
          </h2>
          <p>
            We support all ways of finding talent. From virtual meets to
            physical venues, we&apos;ve got you covered.
          </p>
        </div>

        <div className="audition-types-grid">
          {auditionTypes.map((type, index) => (
            <div className="audition-card" key={index}>
              <div className="audition-card-icon">
                {type.icon}
              </div>

              <h3>{type.title}</h3>
              <p className="audition-card-description">{type.description}</p>

              <ul className="audition-card-features">
                {type.features.map((feature, i) => (
                  <li key={i}>
                    <CheckCircle2 size={16} />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AuditionTypesSection;